import React, { useCallback } from 'react';
import cx from 'classnames';
import styles from './Suggestion.module.css';
var Suggestion = function (_a) {
    var _b;
    var tabIndex = _a.tabIndex, className = _a.className, isFocused = _a.isFocused, suggestion = _a.suggestion, withDivider = _a.withDivider, onClick = _a.onClick, onFocusParent = _a.onFocusParent, renderSuggestion = _a.renderSuggestion;
    var handleKeyPress = useCallback(function (event) {
        switch (event.key) {
            case 'Enter':
                onClick(suggestion);
                break;
            default:
                break;
        }
    }, [onClick, suggestion]);
    var handleClick = useCallback(function () {
        onClick(suggestion);
    }, [onClick, suggestion]);
    var handleFocus = useCallback(function () {
        onFocusParent();
    }, [onFocusParent]);
    return (React.createElement("li", { role: "option", tabIndex: tabIndex, "aria-selected": isFocused, className: cx(styles.suggestion, className, (_b = {},
            _b[styles.focused] = isFocused,
            _b)), onFocus: handleFocus, onClick: handleClick, onKeyPress: handleKeyPress }, renderSuggestion === null || renderSuggestion === void 0 ? void 0 :
        renderSuggestion(suggestion),
        withDivider && React.createElement("hr", { className: styles.divider })));
};
export default Suggestion;
//# sourceMappingURL=Suggestion.js.map